import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { Observable } from 'rxjs';
import {
  IInviteUser,
  IInviteUserResponse,
  IProfileEdit,
  IUpdateUserRequest,
  IUser,
} from '../interfaces';

@Injectable({
  providedIn: 'root',
})
export class UsersManagementService {
  readonly #http = inject(HttpClient);
  private apiUrl = `${environment.apiUrl}`;

  getUsers(): Observable<IUser[]> {
    return this.#http.get<IUser[]>(`${this.apiUrl}/users`);
  }

  getUser(id: string): Observable<IUser> {
    return this.#http.get<IUser>(`${this.apiUrl}/users/get-user-by-id/${id}`);
  }

  inviteUser(user: IInviteUser): Observable<IInviteUserResponse> {
    return this.#http.put<IInviteUserResponse>(
      `${this.apiUrl}/auth/invite-user`,
      {
        email: user.email,
        userRole: user.userRole.id,
      },
    );
  }

  getPendingUsers(): Observable<IInviteUserResponse[]> {
    return this.#http.get<IInviteUserResponse[]>(
      `${this.apiUrl}/auth/get-pending-users`,
    );
  }

  updateUser(id: string, user: IProfileEdit): Observable<IUser> {
    const payload: IUpdateUserRequest = {
      firstName: user.firstName,
      lastName: user.lastName,
      phoneNumber: user.phoneNumber,
      userRole: user.userRole?.id,
    };

    return this.#http.put<IUser>(`${this.apiUrl}/users/update-user/${id}`, {
      ...payload,
    });
  }

  deleteUser(userId: string): Observable<string> {
    return this.#http.delete(`${this.apiUrl}/users/delete-user/${userId}`, {
      responseType: 'text',
    });
  }
}
